import React, { useEffect, useState } from "react";
import { getAllCrews } from "../API";
import AllCrewsTable from "../components/AllCrewsTable";
import Loader from "./Loader";
import AddNewCrewModal from "../components/AddNewCrewModal";

const AllCrewsManagement = () => {
  const [crewData, setCrewData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const user_id = JSON.parse(localStorage.getItem("user_id"));
  const roleName = localStorage.getItem("role_name");

  const fetchAllCrews = async () => {
    await getAllCrews()
      .then((res) => {
        if (res?.status === 200) {
          setIsLoading(false);

          if (user_id && (roleName === "General Foreman" || "Ops Manager")) {
            const genForemanCrews = res?.data?.filter((crew) => {
              let findGenForemanCrew;
              if (
                roleName === "General Foreman" ||
                roleName === "Foreman GeneralForeman"
              ) {
                findGenForemanCrew = crew?.crew_user?.find(
                  (user) =>
                    user?.user_id === user_id && user?.crew_role_id === 2
                );
                return findGenForemanCrew;
              } else if (
                roleName === "Ops Manager" ||
                roleName === "Foreman OpsManager"
              ) {
                findGenForemanCrew = crew?.crew_user?.find(
                  (user) =>
                    user?.user_id === user_id && user?.crew_role_id === 3
                );
                return findGenForemanCrew;
              }
            });
            setCrewData(genForemanCrews);
          } else {
            setCrewData(res?.data);
          }
        }
      })
      .catch((err) =>
        console.log("Error occured in AllCrewsManagement component", err)
      );
  };
  useEffect(() => {
    fetchAllCrews();
  }, []);

  const addNewCrewUser = () => {
    fetchAllCrews();
  };
  return (
    <div className="project-details">
      <div
        style={{ display: "flex", justifyContent: "space-between" }}
        className="timesheet"
      >
        <h2 className="title">All Crews</h2>

        <div className="options">
          {!user_id && roleName === "Admin" && (
            <AddNewCrewModal addNewCrewUser={addNewCrewUser} />
          )}
          {/* <SideDropDownOptions /> */}
        </div>
      </div>
      <div className="crew-info"></div>
      {isLoading ? (
        <Loader />
      ) : crewData && crewData.length > 0 ? (
        <AllCrewsTable crewData={crewData} isLoading={isLoading} />
      ) : (
        <div>No data</div>
      )}
    </div>
  );
};

export default AllCrewsManagement;
